import axios from 'axios';
import { useAuthStore } from '@/lib/stores/authStore';

/**
 * Encerra a sessão local assim que a API rejeitar o token.
 * Sem isto, um token expirado continua marcado como autenticado no
 * localStorage e o usuário fica preso em telas que só retornam erro.
 */
export function registrarInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const { isAuthenticated, logout } = useAuthStore.getState();
        if (isAuthenticated) {
          logout();
          window.location.assign('/login');
        }
      }
      return Promise.reject(error);
    },
  );
}
